<script setup lang="ts">
import sellImg from '@/assets/imgs/c2c-sell.png'
</script>

<template>
  <div class="popup">
    <div class="join">
      <h1 class="title">{{ $t('uutXn6aMg4hBQuANzuxtp') }}</h1>
      <p class="info">{{ $t("UMUMG88lXPv-_66YBiNVX") }}</p>
      <div class="box">
        <a
          class="join-button text-primary-100 font-bold flex-center !lt-laptopl:w-170px lt-laptopl:my-30px lt-laptopl:left-[50%] lt-laptopl:translate-x--50%"
          target="_blank"
          href="/console/seller/dashboard"
          data-test-id="MOPL"
        >
          {{ $t("NnsTZYWugx8piHOPgXaUp") }}
        </a>
        <div class="link link1">
          <i class="i-local:tg-s4 icon" />
          <a class="link-text" href="https://t.me/tronenergymarkets" target="_blank" data-test-id="lbNl">{{ $t("P5vQ5M3DaK_vUetztkJKS") }}</a>
        </div>
        <div class="link link2 w-50% lt-tabletl:w-full">
          <i class="i-local:tg-s4 icon" />
          <a class="link-text" href="https://t.me/trongascom" target="_blank" data-test-id="Uefb">{{ $t("-gpqytKeCEd_i6GCpio91") }}：<br> @trongascom</a>
        </div>
      </div>
      <img :src="sellImg" class="sell-img w-163px h-166px">
    </div>
  </div>
</template>

<style scoped lang="scss">
.popup {
  width: 100%;
  height: 230px;
  padding: 30px;
  color: var(--first-text);
  background: linear-gradient(225deg, #192038, #2e3f74);
  border-radius: 30px;

  .join {
    display: grid;
    grid-template-rows: 50px 50px 70px;
    grid-template-columns: 600px auto;
    gap: 0 30px;
    justify-content: space-between;
    margin: auto 0;

    .title{
      font-size: 22px;
      font-weight: bold;
    }

    .info {
      grid-row: 2;
      grid-column: 1;
      font-size: 14px;
      line-height: 20px;
    }

    .box {
      display: flex;
      grid-row: 3;
      grid-column: 1;
      align-items: center;
      justify-content: flex-start;

      & > * {
        width: 30%;
      }

      .link {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .link-text {
        margin-left: 10px;
        font-size: 14px;
        line-height: 20px;
        color: var(--secondary-text);
      }
    }

    .join-button {
      width: 28%;
      height: 40px;
      font-size: 16px;
      color: var(--first-text);
      background: #266ef1;
      border: none;
      border-radius: 10px;

      &:hover, &:active {
        background: linear-gradient(90deg,#2680EB,#00C1A5) no-repeat;
      }
    }

    .sell-img {
      grid-row: 1/2;
      grid-column: 2;
      margin-right: 20px;
    }
  }
}

@media bp-lt-laptopl {
  .popup {
    height: auto;
    padding: 0;
    background: none;

    .join {
      display: grid;
      grid-template-rows: auto auto auto auto;
      grid-template-columns: 1fr;
      gap: 0;

      .title {
        grid-row: 1;
        grid-column: 1;
        margin-bottom: 24px;
        font-weight: normal;
        font-weight: bold;
        text-align: center;
      }

      .info {
        grid-row: 2;
        grid-column: 1;
      }

      .box {
        display: block;
        grid-row: 4;
        grid-column: 1;
        text-align: center;

        > * {
          flex-wrap: wrap;
          width: 100%;
        }

        button {
          width: 170px;
          margin: 30px 0;
          font-size: 16px;
        }

        .link2 {
          margin-top: 13px;
        }

        i {
          font-size: 18px;
        }
      }

      .join-button {
        position: relative;
        left: 50%;
      }

      .sell-img {
        position: relative;
        left: 50%;
        grid-row: 3;
        grid-column: 1;
        margin-top: 28px;
        margin-right: 0;
        transform: translateX(-50%);
      }
    }
  }
}
</style>
